import * as React from "react";
import type { SVGProps } from "react";
const SvgImportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="import_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M786.944 307.627a298.88 298.88 0 0 0-486.699-90.88 298.837 298.837 0 0 0-83.882 171.52A170.837 170.837 0 0 0 142.89 682.24a170.837 170.837 0 0 0 113.621 42.923 42.667 42.667 0 1 0 0-85.376 85.419 85.419 0 0 1 0-170.795 42.667 42.667 0 0 0 42.71-42.667A213.419 213.419 0 0 1 622.207 243.5a213.461 213.461 0 0 1 92.587 114.048 42.667 42.667 0 0 0 33.28 28.586 128.128 128.128 0 0 1 79.701 201.387c-17.067 23.381-41.557 40.277-69.461 48a42.795 42.795 0 0 0 21.333 82.773 213.547 213.547 0 0 0 118.06-332.074 213.504 213.504 0 0 0-110.763-78.592zm-243.84 216.49a42.667 42.667 0 0 0-14.08-8.96c-10.41-4.266-22.101-4.266-32.47 0a42.667 42.667 0 0 0-14.08 8.96l-128.17 128.086a42.88 42.88 0 1 0 60.672 60.586l55.083-55.466v238.634a42.667 42.667 0 1 0 85.418 0V657.323l55.083 55.466a42.752 42.752 0 0 0 69.973-13.866 42.624 42.624 0 0 0-9.344-46.72L543.104 524.117z"
    />
  </svg>
);
export default SvgImportIcon;
